"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { BRAND, mediaPath } from "@/lib/media";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
const FOOTER_STYLE = `
    .footer-link  { border-bottom: 1px solid transparent; transition: border-color .15s, color .15s; }
    .footer-link:hover { border-bottom-color: #DF6D2A; color: #F4EFE6; }
`;
const QUICK_LINKS = [{
  label: "Girmitiya Proud",
  href: "/girmitiya-proud"
}, {
  label: "About Us",
  href: "/about"
}, {
  label: "Events & Webinars",
  href: "/events"
}, {
  label: "Digital Archive",
  href: "/archives"
}, {
  label: "Publications",
  href: "/publications"
}, {
  label: "Contact",
  href: "/contact"
}];
const TEAM_LINKS = [{
  label: "Governing Council",
  href: "/governing-council"
}, {
  label: "Research & Projects",
  href: "/reports"
}];

// Inline SVGs — no lucide brand icons needed
const FacebookIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const InstagramIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const YouTubeIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 11.75a29 29 0 00.46 5.33 2.78 2.78 0 001.95 1.96C5.12 19.5 12 19.5 12 19.5s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96 29 29 0 00.46-5.25 29 29 0 00-.46-5.41z" /><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="currentColor" stroke="none" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const SOCIALS = [{
  Icon: FacebookIcon,
  href: "https://www.facebook.com/people/Global-Girmitiya-Council/61585188579833/",
  label: "Facebook"
}, {
  Icon: InstagramIcon,
  href: "https://www.instagram.com/global_girmitiya_council/",
  label: "Instagram"
}, {
  Icon: YouTubeIcon,
  href: "https://www.youtube.com/@Girmitiyacouncil/shorts",
  label: "YouTube"
}];
const Footer = () => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{FOOTER_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <img src={mediaPath(BRAND.logo)} alt={BRAND.logoAlt} width={120} height={120} className="h-12 sm:h-16 md:h-20 w-auto object-contain flex-shrink-0" decoding="async" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-3 sm:gap-4">{t1}<div className="flex flex-col leading-none"><span className="font-display text-[22px] sm:text-[28px] md:text-[34px] font-semibold text-[#F4EFE6] tracking-[-0.01em] leading-tight">Global Girmitiya Council</span><span className="font-body text-[9px] sm:text-[10px] tracking-[0.15em] uppercase text-[#C9A84C] font-light mt-1">Preserving the Indenture Legacy</span></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="border-b border-white/10"><div className="max-w-[1280px] mx-auto px-6 md:px-8 py-10 flex flex-col md:flex-row md:items-center justify-between gap-6">{t2}<div className="flex flex-col sm:flex-row gap-3"><Link href="/contact" className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 text-[12px] tracking-[0.1em] uppercase transition-colors">Get in Touch<ArrowUpRight size={14} strokeWidth={1.5} /></Link><Link href="/about" className="inline-flex items-center justify-center gap-2 px-5 py-3 border border-white/20 text-white/70 text-[12px] tracking-[0.1em] uppercase hover:border-white/40 hover:text-white transition-colors">About the Council</Link></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-[14px]  leading-relaxed text-white/52 max-w-[280px]">A cultural and academic organisation dedicated to preserving the history, language, and contributions of Girmitiya communities worldwide.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-5">{t4}<div className="flex items-center gap-2">{SOCIALS.map(_temp)}</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="text-[14px] tracking-[0.2em] uppercase text-white/60 font-light">Links</h2>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-4">{t6}<ul className="flex flex-col gap-2.5 list-none">{QUICK_LINKS.map(_temp2)}</ul></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h2 className="text-[14px] tracking-[0.2em] uppercase text-white/60 font-light">Our Team</h2>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex flex-col gap-4">{t8}<ul className="flex flex-col gap-2.5 list-none">{TEAM_LINKS.map(_temp3)}</ul></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h2 className="text-[14px] tracking-[0.2em] uppercase text-white/60 font-light">Contact</h2>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <li className="flex gap-3"><MapPin size={14} strokeWidth={1.5} className="text-[#DF6D2A] flex-shrink-0 mt-0.5" /><address className="not-italic text-[13px] leading-relaxed text-white/52">203, 1st Floor, Block-A, Sangam River Apartment, Varuna Vihar Colony, Varanasi, UP 221002</address></li>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li><a href="mailto:info@girmitiyacouncil.in" className="flex items-center gap-3 text-[13px] font-light text-white/52 hover:text-white transition-colors"><Mail size={14} strokeWidth={1.5} className="text-[#DF6D2A] flex-shrink-0" />info@girmitiyacouncil.in</a></li>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="max-w-[1280px] mx-auto px-6 md:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">{t5}{t7}{t9}<div className="flex flex-col gap-4">{t10}<ul className="flex flex-col gap-4 list-none">{t11}{t12}<li><a href="tel:+919415949494" className="flex items-center gap-3 text-[13px] font-light text-white/52 hover:text-white transition-colors"><Phone size={14} strokeWidth={1.5} className="text-[#DF6D2A] flex-shrink-0" />+91-94159 49494</a></li></ul></div></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p className="text-[13px] text-white/52 tracking-wide">© 2026 Global Girmitiya Council. All rights reserved.</p>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <>{t0}<footer className="font-body bg-[#0F1C2E] text-[#F4EFE6]">{t3}{t13}<div className="border-t border-white/10"><div className="max-w-[1280px] mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">{t14}<p className="text-[13px] text-white/55 tracking-wide flex items-center gap-1.5 flex-wrap justify-center sm:justify-end">Developed by{" "}<a href="https://launchwebx.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors duration-300">LaunchWebX</a><span className="text-[#C9A84C] text-[11px]">×</span><a href="https://nextgrow.in" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors duration-300">Nextgrow</a></p></div></div></footer></>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
};
export default Footer;
function _temp(t0) {
  const {
    Icon,
    href,
    label
  } = t0;
  return <a key={label} href={href} aria-label={label} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-8 h-8 border border-white/15 text-white/45 hover:border-[#DF6D2A] hover:text-[#C05A3F] transition-colors"><Icon /></a>;
}
function _temp2(t0) {
  const {
    label: label_0,
    href: href_0
  } = t0;
  return <li key={href_0}><Link href={href_0} className="footer-link text-[13px] text-white/52 pb-px">{label_0}</Link></li>;
}
function _temp3(t0) {
  const {
    label: label_1,
    href: href_1
  } = t0;
  return <li key={href_1}><Link href={href_1} className="footer-link text-[13px] text-white/52 pb-px">{label_1}</Link></li>;
}